import apiCall from '@/store/apiCall';
import URLS from '@/store/urls';
import notificationWithIcon from '@/utils/notification';
import types from './types';

export default {
  // Dashboard
  async getOverview({ commit }, payload) {
    try {
      commit(types.GET_OVERVIEW_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.analyticsDashboard}/overview`,
        params: payload,
        isToken: true,
      });
      commit(types.GET_OVERVIEW_SUCCESS, data);
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      notificationWithIcon('error', message);
      commit(types.GET_OVERVIEW_FAILURE, message);
    }
  },

  async getErrorTrend({ commit }, payload) {
    try {
      commit(types.GET_ERROR_TREND_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.analyticsDashboard}/errors-trend`,
        params: payload,
        isToken: true,
      });
      commit(types.GET_ERROR_TREND_SUCCESS, data);
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      commit(types.GET_ERROR_TREND_FAILURE, message);
    }
  },

  async getErrorsByType({ commit }, payload) {
    try {
      commit(types.GET_ERRORS_BY_TYPE_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.analyticsDashboard}/errors-by-type`,
        params: payload,
        isToken: true,
      });
      commit(types.GET_ERRORS_BY_TYPE_SUCCESS, data);
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      commit(types.GET_ERRORS_BY_TYPE_FAILURE, message);
    }
  },

  async getErrorsByBrowser({ commit }, payload) {
    try {
      commit(types.GET_ERRORS_BY_BROWSER_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.analyticsDashboard}/errors-by-browser`,
        params: payload,
        isToken: true,
      });
      commit(types.GET_ERRORS_BY_BROWSER_SUCCESS, data);
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      commit(types.GET_ERRORS_BY_BROWSER_FAILURE, message);
    }
  },

  async getErrorsByPage({ commit }, payload) {
    try {
      commit(types.GET_ERRORS_BY_PAGE_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.analyticsDashboard}/errors-by-page`,
        params: payload,
        isToken: true,
      });
      commit(types.GET_ERRORS_BY_PAGE_SUCCESS, data);
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      commit(types.GET_ERRORS_BY_PAGE_FAILURE, message);
    }
  },

  async getApiPerformance({ commit }, payload) {
    try {
      commit(types.GET_API_PERFORMANCE_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.analyticsDashboard}/api-performance`,
        params: payload,
        isToken: true,
      });
      commit(types.GET_API_PERFORMANCE_SUCCESS, data);
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      commit(types.GET_API_PERFORMANCE_FAILURE, message);
    }
  },

  // Sessions
  async getSessions({ commit }, payload) {
    try {
      commit(types.GET_SESSIONS_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: URLS.sessions,
        params: payload,
        isToken: true,
      });
      commit(types.GET_SESSIONS_SUCCESS, data);
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      notificationWithIcon('error', message);
      commit(types.GET_SESSIONS_FAILURE, message);
    }
  },

  async getSessionDetail({ commit }, id) {
    try {
      commit(types.GET_SESSION_DETAIL_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.sessions}/${id}`,
        isToken: true,
      });
      commit(types.GET_SESSION_DETAIL_SUCCESS, data);
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      notificationWithIcon('error', message);
      commit(types.GET_SESSION_DETAIL_FAILURE, message);
    }
  },

  async getSessionEvents({ commit }, id) {
    try {
      commit(types.GET_SESSION_EVENTS_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.sessions}/${id}/events`,
        isToken: true,
      });
      commit(types.GET_SESSION_EVENTS_SUCCESS, data);
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      notificationWithIcon('error', message);
      commit(types.GET_SESSION_EVENTS_FAILURE, message);
    }
  },

  clearSessionDetail({ commit }) {
    commit(types.CLEAR_SESSION_DETAIL);
  },

  // Heatmaps
  async getHeatmapPages({ commit }, payload) {
    try {
      commit(types.GET_HEATMAP_PAGES_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.heatmaps}/pages`,
        params: payload,
        isToken: true,
      });
      commit(types.GET_HEATMAP_PAGES_SUCCESS, data);
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      notificationWithIcon('error', message);
      commit(types.GET_HEATMAP_PAGES_FAILURE, message);
    }
  },

  async getHeatmapClicks({ commit }, payload) {
    try {
      commit(types.GET_HEATMAP_CLICKS_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.heatmaps}/clicks`,
        params: payload,
        isToken: true,
      });
      commit(types.GET_HEATMAP_CLICKS_SUCCESS, data);
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      notificationWithIcon('error', message);
      commit(types.GET_HEATMAP_CLICKS_FAILURE, message);
    }
  },

  // Frontend Errors
  async getFrontendErrors({ commit }, payload) {
    try {
      commit(types.GET_FRONTEND_ERRORS_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: URLS.frontendErrors,
        params: payload,
        isToken: true,
      });
      commit(types.GET_FRONTEND_ERRORS_SUCCESS, data);
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      notificationWithIcon('error', message);
      commit(types.GET_FRONTEND_ERRORS_FAILURE, message);
    }
  },

  async getFrontendErrorDetail({ commit }, id) {
    try {
      commit(types.GET_FRONTEND_ERROR_DETAIL_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.frontendErrors}/${id}`,
        isToken: true,
      });
      commit(types.GET_FRONTEND_ERROR_DETAIL_SUCCESS, data);
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      notificationWithIcon('error', message);
      commit(types.GET_FRONTEND_ERROR_DETAIL_FAILURE, message);
    }
  },

  async resolveFrontendErrors({ commit, dispatch }, { ids, isResolved, filters }) {
    try {
      commit(types.RESOLVE_FRONTEND_ERRORS_START);
      await apiCall({
        type: 'PUT',
        url: `${URLS.frontendErrors}/resolve`,
        body: { ids, isResolved },
        isToken: true,
      });
      commit(types.RESOLVE_FRONTEND_ERRORS_SUCCESS);
      notificationWithIcon('success', `${ids.length} error(s) ${isResolved ? 'resolved' : 'reopened'}`);
      if (filters) {
        dispatch('getFrontendErrors', filters);
      }
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      notificationWithIcon('error', message);
      commit(types.RESOLVE_FRONTEND_ERRORS_FAILURE, message);
    }
  },

  clearFrontendErrorDetail({ commit }) {
    commit(types.CLEAR_FRONTEND_ERROR_DETAIL);
  },

  // Alerts
  async getAlertRules({ commit }) {
    try {
      commit(types.GET_ALERT_RULES_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.alerts}/rules`,
        isToken: true,
      });
      commit(types.GET_ALERT_RULES_SUCCESS, data);
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      notificationWithIcon('error', message);
      commit(types.GET_ALERT_RULES_FAILURE, message);
    }
  },

  async getAlertHistory({ commit }, payload) {
    try {
      commit(types.GET_ALERT_HISTORY_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.alerts}/history`,
        params: payload,
        isToken: true,
      });
      commit(types.GET_ALERT_HISTORY_SUCCESS, data);
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      notificationWithIcon('error', message);
      commit(types.GET_ALERT_HISTORY_FAILURE, message);
    }
  },

  async createAlertRule({ commit, dispatch }, payload) {
    try {
      commit(types.CREATE_ALERT_RULE_START);
      await apiCall({
        type: 'POST',
        url: `${URLS.alerts}/rules`,
        body: payload,
        isToken: true,
      });
      commit(types.CREATE_ALERT_RULE_SUCCESS);
      notificationWithIcon('success', 'Alert rule created');
      dispatch('getAlertRules');
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      notificationWithIcon('error', message);
      commit(types.CREATE_ALERT_RULE_FAILURE, message);
    }
  },

  async updateAlertRule({ commit, dispatch }, { id, payload }) {
    try {
      commit(types.UPDATE_ALERT_RULE_START);
      await apiCall({
        type: 'PUT',
        url: `${URLS.alerts}/rules/${id}`,
        body: payload,
        isToken: true,
      });
      commit(types.UPDATE_ALERT_RULE_SUCCESS);
      notificationWithIcon('success', 'Alert rule updated');
      dispatch('getAlertRules');
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      notificationWithIcon('error', message);
      commit(types.UPDATE_ALERT_RULE_FAILURE, message);
    }
  },

  async deleteAlertRule({ commit, dispatch }, id) {
    try {
      commit(types.DELETE_ALERT_RULE_START);
      await apiCall({
        type: 'DELETE',
        url: `${URLS.alerts}/rules/${id}`,
        isToken: true,
      });
      commit(types.DELETE_ALERT_RULE_SUCCESS);
      notificationWithIcon('success', 'Alert rule deleted');
      dispatch('getAlertRules');
    } catch (e) {
      const message = e.response?.data?.message || e.message;
      notificationWithIcon('error', message);
      commit(types.DELETE_ALERT_RULE_FAILURE, message);
    }
  },
};
